import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";

import { LOGIN_MODAL } from "../constants/ModalConstants";
import getIdSelector from "../state/selectors/ClientSelectors/getIdSelector";
import setActiveModalAction from "../state/actions/ModalActions/setActiveModalAction";
import { useCallback } from "react";

export default function useHistoryPushPreventUnlogged(to: string) {
    const isUserLoggedIn = useSelector((state: Store) => getIdSelector(state));
    const dispatch = useDispatch();
    const openModal = useCallback(() => dispatch(setActiveModalAction(LOGIN_MODAL)), [dispatch]);
    const match = useRouteMatch({
        path: to,
        exact: true
    });
    const history = useHistory();
    return () => {
        if (!isUserLoggedIn) {
            openModal();
        } else if (!match) {
            history.push(to);
        }
    };
}
